import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Switch,
  FormControlLabel,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Divider,
  TextField,
  Button,
  Grid,
} from '@mui/material';

const SampleSettings: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ color: 'secondary.main', fontWeight: 700, mb: 1 }}>
        Settings
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 3 }}>
        Configure your account and notification preferences
      </Typography>

      <Grid container spacing={3}>
        {/* Notifications */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, border: 1, borderColor: 'divider' }}>
            <Typography variant="h6" sx={{ color: 'secondary.main', fontWeight: 600, mb: 2 }}>
              Notifications
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="Email notifications"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="Weekly summary reports"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch color="primary" />}
                label="SMS alerts for critical issues"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="AI insight notifications"
                sx={{ color: 'secondary.main' }}
              />
            </Box>
          </Paper>
        </Grid>

        {/* Data Preferences */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, border: 1, borderColor: 'divider' }}>
            <Typography variant="h6" sx={{ color: 'secondary.main', fontWeight: 600, mb: 2 }}>
              Data Preferences
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="Auto-sync connected sources"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="AI-powered categorization"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch color="primary" />}
                label="Share anonymous analytics"
                sx={{ color: 'secondary.main' }}
              />
              <FormControlLabel
                control={<Switch defaultChecked color="primary" />}
                label="Data retention (2 years)"
                sx={{ color: 'secondary.main' }}
              />
            </Box>
          </Paper>
        </Grid>

        {/* Company Info */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3, border: 1, borderColor: 'divider' }}>
            <Typography variant="h6" sx={{ color: 'secondary.main', fontWeight: 600, mb: 2 }}>
              Company Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  defaultValue="Acme Widgets Inc."
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Industry"
                  defaultValue="E-commerce / Retail"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Timezone"
                  defaultValue="America/New_York (EST)"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Currency"
                  defaultValue="USD ($)"
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
            <Box sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: 'primary.main',
                  '&:hover': { bgcolor: 'primary.dark' },
                }}
              >
                Save Changes
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SampleSettings;
